// src/pages/playlists/playlistsApi.js
// HTTP calls for playlists, plus the two archive searches the picker reuses.
import { api } from "../../api";

const PAGE = 20;

export const fetchPlaylists = () => api.get("/playlists").then((r) => r.data.playlists || []);
export const fetchPlaylist = (id) => api.get(`/playlists/${encodeURIComponent(id)}`).then((r) => r.data.playlist);
export const createPlaylistReq = (body) => api.post("/playlists", body).then((r) => r.data.playlist);
export const updatePlaylistReq = (id, body) =>
  api.patch(`/playlists/${encodeURIComponent(id)}`, body).then((r) => r.data.playlist);
export const deletePlaylistReq = (id) => api.delete(`/playlists/${encodeURIComponent(id)}`);
export const restorePlaylistReq = (snapshot) =>
  api.post(`/playlists/${encodeURIComponent(snapshot.id)}/restore`, snapshot).then((r) => r.data.playlist);

export async function searchAudio({ q, cursor }) {
  const { data } = await api.get("/audio-lectures", {
    params: { search: q || undefined, cursor: cursor || undefined, limit: PAGE },
  });
  return { items: data.data || [], nextCursor: data.nextCursor || null, hasMore: !!data.hasMore };
}

export async function searchVideo({ q, cursor }) {
  const { data } = await api.get("/video-lectures/history", {
    params: { q: q || undefined, cursor: cursor || undefined, limit: PAGE },
  });
  const items = data.items || [];
  return { items, nextCursor: data.nextCursor || null, hasMore: items.length === PAGE };
}

export function errorMessage(err, fallback) {
  return err?.response?.data?.message || fallback;
}
